export {type CollectionBuilderContext} from '../../../src/table/useTableState';
